
export const env = {
    API_SERVER: `${process.env.REACT_APP_API_URL}/api/v1`,
}